{
  "allApps": "Todos os aplicativos",
  "back": "Voltar ao principal",
  "myApps": "Meus aplicativos",
  "viewMoreApps": "Visualização de mais aplicativos"
}
